module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.0.0.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA1.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA1.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA1.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA1.w.1.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PP1"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA1.w.1.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA1.w.1.2.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PP2"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA1.w.2.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "Image for page 1",
      "src": "data/content-0002.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA1.w.2.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page full_page_skipped",
    attrs: {
      "id": "ORIG-GBS.PP3"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page full_page_skipped",
    attrs: {
      "id": "ORIG-GBS.PP4"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.4.0.0.box.404.616.784.744.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA1.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "160%",
      "font-weight": "bold",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.4.0.0.box.404.616.784.744.q.90"
    }
  }, [_vm._v("THE SAINTS THE SUPERD"), _c('a', {
    attrs: {
      "id": "GBS.PA1.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA1.w.2.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA1.w.3.0.0"
    }
  }), _vm._v("OME AND THE SCANDAL")]), _c('a', {
    attrs: {
      "id": "GBS.PA1.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA2"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA2.w.0.0.0"
    }
  })])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.0.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA3"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.6.0.0.box.364.274.862.942.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "166%",
      "font-weight": "bold",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.6.0.0.box.364.274.862.942.q.90"
    }
  }, [_c('b', [_vm._v("THE ")]), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.0.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.1.1.0"
    }
  }), _vm._v("SAINTS THE SUPERDOME "), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.1.2.0"
    }
  }), _vm._v("AND THE SCANDAL")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.6.1.0.box.402.1346.446.197.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.6.1.0.box.402.1346.386.106.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.2.0.0"
    }
  }), _vm._v("Dave Dixon")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-weight": "bold",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.6.1.1.box.406.1492.442.51.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.2.1.0"
    }
  }), _vm._v("Foreword by Peter Finney")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.6.2.0.box.740.2152.102.96.q.0"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.3.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0003.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.3.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.6.3.0.box.404.2274.783.89.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-align": "center",
      "font-weight": "bold",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.6.3.0.box.404.2274.783.35.q.100"
    }
  }, [_vm._v("PELICAN PUBLISHING COMPANY")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA3.w.3.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.6.3.1.box.659.2328.272.35.q.90"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Gretna ")]), _vm._v("2008")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA4"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.7.0.0.box.197.259.344.142.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-left": "0",
      "margin-bottom": "0",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.7.0.0.box.198.259.324.42.q.100"
    }
  }, [_vm._v("Copyright © 2008")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-left": "0",
      "margin-bottom": "0",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.7.0.1.box.198.310.278.41.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.0.1.0"
    }
  }), _vm._v("By Dave Dixon")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-left": "0",
      "margin-bottom": "0",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.7.0.2.box.197.359.344.42.q.90"
    }
  }, [_vm._v("All rights reserved")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.7.1.0.box.295.910.1096.144.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.7.1.0.box.295.910.1096.144.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.1.0.0"
    }
  }), _vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("word ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("\"Pelican\" ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("depiction ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("pelican ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("are ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("trademarks ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Pelican ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Publishing ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Company, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Inc., ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("are ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("registered ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("U.S. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Patent ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Trademark ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Office. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.7.2.0.box.196.1261.1251.579.q.40"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "0",
      "text-align": "center",
      "font-weight": "bold",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.7.2.0.box.350.1261.985.42.q.80"
    }
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.7.2.1.box.198.1360.348.35.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.2.0.0"
    }
  }), _vm._v("Dixon, Dave, 1923-")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_lineated",
    staticStyle: {
      "margin-left": "0",
      "margin-top": "0.5em",
      "margin-bottom": "0.5em",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.7.2.2.box.196.1409.1251.380.q.30"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.2.1.0"
    }
  }), _vm._v(" The Saints, the Superdome, and the scandal / Dave Dixon ; fore- "), _c('br'), _vm._v("word by Peter Finney. "), _c('br'), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.4.0.0"
    }
  }), _vm._v("         p. cm. "), _c('br'), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.4.1.0"
    }
  }), _vm._v("   ISBN 978-1-58980-493-7 (hardcover : alk. paper) 1. New Orleans "), _c('br'), _vm._v("Saints (Football team) — History. 2. Superdome (New Orleans, La.) —"), _c('br'), _vm._v("History. 3. Dixon, Dave, 1923- I. Title. "), _c('br'), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.4.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.5.0.0"
    }
  }), _vm._v("  GV956.N366D59 2008 "), _c('br'), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.6.0.0"
    }
  }), _vm._v("  796.332'640976335 — dc22 "), _c('br')]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.2.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "0",
      "text-align": "right",
      "margin-right": "8em",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.7.2.3.box.885.1809.208.31.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.7.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.8.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.9.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.10.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.11.0.0"
    }
  }), _vm._v("2007048297")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    staticStyle: {
      "float": "none"
    },
    attrs: {
      "id": "block.7.3.0.box.198.2030.220.92.q.0"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.12.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0004.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA4.w.12.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.7.4.0.box.197.2157.878.148.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.4.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "color": "rgb(0, 0, 0)",
      "clear": "both"
    },
    attrs: {
      "id": "para.7.4.0.box.198.2157.726.32.q.80"
    }
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA4.w.4.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.7.4.1.box.197.2219.878.86.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA4.w.12.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.0.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.0.2.0"
    }
  }), _vm._v("Published by Pelican "), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.0.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.0.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.0.0"
    }
  }), _vm._v("Publishing Company, I"), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.2.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.2.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.2.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.2.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.2.6.0"
    }
  }), _vm._v("nc. 1000 Burmaster St"), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.2.7.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.2.8.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.2.9.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.2.10.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.2.11.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.3.1.0"
    }
  }), _vm._v("reet, Gretna, Louisia"), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.5.0.0"
    }
  }), _vm._v("na 70053")]), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.5.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.5.2.0"
    }
  })]), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.5.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.5.4.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.5.5.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.5.6.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.5.7.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.5.7.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.5.8.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page full_page_skipped",
    attrs: {
      "id": "ORIG-GBS.PA5"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA6"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    staticStyle: {
      "float": "none"
    },
    attrs: {
      "id": "block.9.0.0.box.188.130.727.1001.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.5.9.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0005.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.5.9.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "float": "none"
    },
    attrs: {
      "id": "block.9.1.0.box.941.883.525.258.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA6.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.9.1.0.box.941.883.525.258.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("New ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.5.10.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.5.11.0"
    }
  }), _vm._v("Orleans ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.5.12.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.5.13.0"
    }
  }), _vm._v("Magazine ")]), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.5.14.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.5.15.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.5.16.0"
    }
  }), _vm._v("cover, \"New Orle"), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.5.17.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.5.18.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.6.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.7.0.0"
    }
  }), _vm._v("anians of the Century"), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.7.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.8.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.8.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.8.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.9.0.0"
    }
  }), _vm._v(",\" December 1999"), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.9.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.10.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.11.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.12.0.0"
    }
  }), _vm._v(". (Photo courtesy "), _c('i', [_vm._v("New ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Orleans ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Magazine")]), _vm._v(")")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    staticStyle: {
      "float": "none"
    },
    attrs: {
      "id": "block.9.2.0.box.748.1333.750.996.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.2.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.4.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.6.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0006.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.6.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.9.3.0.box.198.2078.525.258.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA6.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.9.3.0.box.198.2078.525.258.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("New ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6.w.7.0.0"
    }
  }), _vm._v("Orleans ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6.w.7.1.0"
    }
  }), _vm._v("Magazine ")]), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.7.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.7.3.0"
    }
  }), _vm._v("cover, \"Dave Dix"), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.7.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.8.0.0"
    }
  }), _vm._v("on — Superdome "), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.9.0.0"
    }
  }), _vm._v("Mastermind,\" Jul"), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.10.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.11.0.0"
    }
  }), _vm._v("y 1973. (Photo courte"), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.11.1.0"
    }
  }), _vm._v("sy "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("New ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6.w.12.0.0"
    }
  }), _vm._v("Orleans ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6.w.13.0.0"
    }
  }), _vm._v("Magazine")]), _vm._v(")")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.0.0.0.1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-589a7bf0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content-0007.vue
// module id = 54
// module chunks = 0